import styled from 'styled-components';

import {useParams} from "react-router-dom";
import {Brush, Code, Filter, Gavel, Highlighter, Pencil, Scroll, Shield, Tag, Vote} from "lucide-react";
import React from "react";
import NavLink from "../../../components/nav_link";
import {themecolors} from "../../../utils/themecolors";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from '../../../components/top_bar';

const Item = styled.div``;

const CommunitySettings = styled(({className}) => {
    const {community} = useParams();
    return (
        <>
            <FixedTopBar back title="Community Settings" border={false} black />
            <WhiteMain className={className}>
                <NavLink href={`/c/${community}/config/basic`}>
                    <Item>
                        <Pencil size={20} />
                        Basic Information
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/design`}>
                    <Item>
                        <Brush size={20} />
                        Community Design
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/rules`}>
                    <Item>
                        <Scroll size={20} />
                        Community Rules
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/topics`}>
                    <Item>
                        <Tag size={20} />
                        Community Topics
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/filter`}>
                    <Item>
                        <Filter size={20} />
                        Community Filter
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/stylesheet`}>
                    <Item>
                        <Code size={20} />
                        Desktop Stylesheet
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/moderators`}>
                    <Item>
                        <Gavel size={20} />
                        Community Moderators
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/voting`}>
                    <Item>
                        <Vote size={20} />
                        Voting Restrictions
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/content`}>
                    <Item>
                        <Highlighter size={20} />
                        Content Restrictions
                    </Item>
                </NavLink>
                <NavLink href={`/c/${community}/config/privacy`}>
                    <Item>
                        <Shield size={20} />
                        Privacy and Safety
                    </Item>
                </NavLink>
            </WhiteMain>
        </>
    );
})`
  ${Item} {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : 'inherit'};
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
  }

  ${Item} svg {
    margin-right: 20px;
  }

  ${Item}:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : 'rgba(0,0,0,.06)'};
  }
  
`;

export default CommunitySettings;
